module.exports = __webpack_public_path__ + "static/media/03_Coding.73e46139.png";